import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-error403',
  templateUrl: './page-error403.component.html',
  styleUrls: ['./page-error403.component.css']
})
export class PageError403Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
